import type { IHttpRequestRunner } from 'shared/domain/httpRequest/httpRequestRunner';
import { ProtocolItemHttpEditRequestModel } from './types';
import { Fetcher } from '../fetcher';
import { ProtocolItemInDto } from 'shared/dtos/in/protocolItem';

export class ProtocolItemRequestRunner implements IHttpRequestRunner {
  constructor(private fetcher: typeof Fetcher) {}

  async execute(
    request: ProtocolItemHttpEditRequestModel
  ): Promise<ProtocolItemInDto> {
    if (request.method !== 'PUT') {
      throw new Error(
        'ProtocolItemRequestRunner only supports PUT method'
      );
    }

    const response = await this.fetcher.PUT(
      request.url,
      request.data.protocolItemOutDto
    );

    return response as ProtocolItemInDto;
  }
}
